/**
 * 漂流瓶 Manager
 */
import DriftBattleConfig, {DriftBattleEntity, DriftChooseEntity} from "../config/DriftBattleConfig";
import NormalGameManager from "../../../manager/NormalGameManager";
import {DriftBattleCacheData} from "../../../manager/DefineInterface";
import O1HD from "../../../../../engines/gameEngine";
import {getOneWeChatTriggerTimeLinkById} from "../../../config/WeChatTriggerTimeLinkConfig";
import {getOneChitAryById} from "../../../config/WeChatChitChatConfig";
import WeChatFrame from "../../weChat/WeChatFrame";
import {BUNDLE_SMALL_NAME, getOneBundleOnePrefab} from "../../../BundleResourceConfig";
import {PLATFORM_CODE} from "../../../../../engines/services/ossService";

export default class DriftBattleManager{

    private mGameLayer : NormalGameManager;
    constructor( ) {
        this.mGameLayer = NormalGameManager._instance;
    }

    /**
     * 注册当前事件 ( 起始事件 )
     */
    registerStartEvent(){
        //初始事件
        let initEventArray : DriftBattleEntity[] = DriftBattleConfig().filter(( item , index , dataList )=>{
            return item.days == 0;
        });
        this.mGameLayer.getGameData().driftBattleData = [];
        for ( let eventItem of initEventArray ) {
            this.mGameLayer.getGameData().driftBattleData.push( { eventId : eventItem.uniqueId , weight : eventItem.weight } );
        }
        this.mGameLayer.writeGameData();
    }

    /**
     * 跨天，注册事件
     */
    registerCurrDayEvent( day : number ){
        //前置处理
        if ( !this.mGameLayer.getGameData().driftBattleData ) {
            this.mGameLayer.getGameData().driftBattleData = [];
        }
        //延迟 缓存队列 判断
        if ( this.mGameLayer.getGameData().delayDriftBattleData ) {
            for ( let i = 0 ; i < this.mGameLayer.getGameData().delayDriftBattleData.length ; i++ ) {
                let delayDriftBattleItem = this.mGameLayer.getGameData().delayDriftBattleData[i];
                if ( delayDriftBattleItem.actualTriggerDays <= this.mGameLayer.getCurrentDay() + 1 ){
                    this.mGameLayer.getGameData().driftBattleData.push( delayDriftBattleItem as DriftBattleCacheData );
                    this.mGameLayer.getGameData().delayDriftBattleData.splice( i , 1 );
                    i --;
                }
            }
        }

        //事件 配置表 判断
        let dayEventArray : DriftBattleEntity[] = DriftBattleConfig().filter(( item , index , dataList )=>{
            return item.days == day;
        });
        //注册 添加 事件id
        for ( let eventItem of dayEventArray ) {
            this.mGameLayer.getGameData().driftBattleData.push( { eventId : eventItem.uniqueId , weight : eventItem.weight } );
        }
        this.mGameLayer.writeGameData();
    }

    /**
     * 后置事件注册
     * @param id
     */
    registerEventById( id : number ){
        let driftBattleEntity : DriftBattleEntity = DriftBattleConfig().find(
            (item,index,dataList)=>{
                return item.uniqueId == id;
            });
        if ( !driftBattleEntity ) {
            console.error( `注册事件id不存在`,id );
            return;
        }
        if ( !this.mGameLayer.getGameData().driftBattleData ) {
            this.mGameLayer.getGameData().driftBattleData = [];
        }
        this.mGameLayer.getGameData().driftBattleData.push( { eventId : driftBattleEntity.uniqueId , weight : driftBattleEntity.weight } );
        this.mGameLayer.writeGameData();
    }

    /**
     * 获取随机 事件
     */
    getRandomDriftBattleEvent(  ) : DriftBattleEntity {
        console.log( "getRandomDriftBattleEvent" , this.mGameLayer.getGameData().driftBattleData )
        if ( !this.mGameLayer.getGameData().driftBattleData ) {
            return null;
        }

        /**
         * 头三次，必捞出来 一张彩票信息
         */
        if ( this.mGameLayer.getGameData().accumulationBattleCount == 3 &&
            !this.mGameLayer.getGameData().lotteryFuturePrize ) {
                let item = DriftBattleConfig().find(
                    ( item ,index,dataList)=>{return item.uniqueId == 1 }
                    );
            return item;
        }

        if ( !this.mGameLayer.getGameData().driftBattleData.find(item=>item.eventId == 25 ) ) {
            //如果没有邀请卡，则加入
            this.mGameLayer.getGameData().driftBattleData.push({eventId:25,weight:400});
            this.mGameLayer.writeGameData();
        }

        // 如果是h5
        if ( O1HD.getServices().ossSrv.getPlatform() == PLATFORM_CODE.H5 ) {
            if ( this.mGameLayer.getGameData().hasWatchBattleFlag && this.mGameLayer.getGameData().hasWatchBattleFlag == true ) {
                this.mGameLayer.setGameData({ hasWatchBattleFlag : false } , false );
                let itemArray = DriftBattleConfig().filter(
                    ( item ,index,dataList)=>{ return item.days == -2 }
                );
                return itemArray[ Math.floor( Math.random() * itemArray.length )];
            }
            let allWeight : number = 0;
            for ( let driftBattleData of this.mGameLayer.getGameData().driftBattleData ) {
                if ( driftBattleData.eventId == 101 ) {
                    allWeight += 500;
                }else{
                    allWeight += driftBattleData.weight;
                }
            }
            let randomNum = Math.floor( Math.random() * allWeight );
            for(let i = 0;i<this.mGameLayer.getGameData().driftBattleData.length;i++){
                let driftBattleData = this.mGameLayer.getGameData().driftBattleData[i];
                let weight = driftBattleData.eventId == 101 ? 500 : driftBattleData.weight;
                if ( randomNum <= weight ){
                    let driftBattleEntity = DriftBattleConfig().find(
                        ( item , index , dataList )=>{
                            return item.uniqueId == driftBattleData.eventId;
                        });
                    return driftBattleEntity;
                }
                randomNum -= weight;
            }
            //如果超出范围没有随机到物品  ，取出指定的海之精华
            return DriftBattleConfig().find(
                ( item , index , dataList )=>{
                    return item.uniqueId == 101;
                });
        }else{
            //如果开广告后第一次 捞漂流瓶必出发好事件
            if ( this.mGameLayer.getGameData().hasWatchBattleFlag && this.mGameLayer.getGameData().hasWatchBattleFlag == true ) {
                this.mGameLayer.setGameData({ hasWatchBattleFlag : false } , false );
                let itemArray = DriftBattleConfig().filter(
                    ( item ,index,dataList)=>{ return item.days == -2 }
                );
                return itemArray[ Math.floor( Math.random() * itemArray.length )];
            }

            let allWeight : number = 0;
            for ( let driftBattleData of this.mGameLayer.getGameData().driftBattleData ) {
                allWeight += driftBattleData.weight;
            }
            let randomNum = Math.floor( Math.random() * allWeight );

            for(let i = 0;i<this.mGameLayer.getGameData().driftBattleData.length;i++){
                let driftBattleData = this.mGameLayer.getGameData().driftBattleData[i];
                if ( randomNum <= driftBattleData.weight ){
                    let driftBattleEntity = DriftBattleConfig().find(
                        ( item , index , dataList )=>{
                            return item.uniqueId == driftBattleData.eventId;
                        });
                    // console.log(driftBattleEntity,"driftBattleEntity");
                    return driftBattleEntity;
                }
                randomNum -= driftBattleData.weight;
            }
        }

        // for ( let driftBattleData of  ) {
        //     if ( randomNum <= driftBattleData.weight ){
        //         let driftBattleEntity = DriftBattleConfig().find(
        //             ( item , index , dataList )=>{
        //                 return item.uniqueId == driftBattleData.eventId;
        //         });
        //         return driftBattleEntity;
        //     }
        //     randomNum -= driftBattleData.weight;
        // }
        return null;
    }

    /**
     * 消耗事件
     * @param driftBattleEntity 漂流瓶 事件
     * @param chooseIndex 选项下标'
     */
    async consumerEvent( driftBattleEntity : DriftBattleEntity , chooseIndex : number,
    randomLotteryNumArray ?: number[],randomGoldLotteryArray ?: number[], targetNode ?: cc.Node , double : boolean = false) {
        let driftChooseEntity = driftBattleEntity.chooseArray[chooseIndex];
        console.log("consumerEvent driftChooseEntity",driftChooseEntity );
        switch ( driftChooseEntity.type ) {
            case DriftChooseType.CACHE:
                if ( driftChooseEntity.effectNums == 1 ) {
                    let paramMap = driftChooseEntity.extraParamsMap;
                    //双色球
                    let triggerDay : number = this.mGameLayer.getCurrentDay() + 1 + Number( paramMap["lotteryDays"] );
                    //写入缓存数据
                    this.mGameLayer.getGameData().lotteryFuturePrize = { triggerDay : triggerDay , prizeNum : randomLotteryNumArray.map(String) , goldNum : randomGoldLotteryArray.map(String) };
                    //下一次触发天数  假如延迟事件 缓存队列
                    this._addDelayEvent( driftBattleEntity , driftChooseEntity );
                }else if ( driftChooseEntity.effectNums == 2 ) {
                    //期货
                    let paramMap = driftChooseEntity.extraParamsMap;
                    let triggerDay : number = this.mGameLayer.getCurrentDay() + Number( paramMap["triggerDays"] );
                    let triggerGoodsId : number;
                    // if ( triggerDay % 2 == 1 ) {
                    //     //奇数  寒冬
                    //     triggerDay = triggerDay + 1;
                    // }else{
                    //     // 酷暑
                    //     triggerGoodsId = 5;
                    // }
                    triggerGoodsId = 4;
                    this.mGameLayer.getGameData().futuresFuturePrize = { triggerDay : triggerDay , triggerGoodsId : triggerGoodsId };
                    //看是否需要加延迟队列
                    this._addDelayEvent( driftBattleEntity , driftChooseEntity );
                }
                break;
            case DriftChooseType.WE_CHAT:
                // 添加一个剧情
                let weChatId = driftChooseEntity.effectNums;
                let isTrue = this.mGameLayer.addOneWeChatTriggerLinkUnShift( `${weChatId}` );
                if(!isTrue){
                    return;
                }
                // await this.mGameLayer.mGameLayer.onBtnOpenPrefab(null,"weChat");
                //聊天链
                let link = getOneWeChatTriggerTimeLinkById( weChatId );
                //聊天链的初始端
                let chitChat = getOneChitAryById(link.link[0].id);
                //聊天对象 信息
                let people = this.mGameLayer.weChatManager.getOnePeopleById(chitChat.people);
                //聊天对象的队列
                let chitChatQueue = people.peopleChatLinkQueue;
                let chatFramePrefab = await getOneBundleOnePrefab( BUNDLE_SMALL_NAME.WeChatGameBundle, "weChat/prefab/WeChatFrame" );
                let chatFrame = cc.instantiate( chatFramePrefab );
                let cs = chatFrame.getComponent( WeChatFrame );
                if( chitChatQueue.length >0 ){
                    // let chitChat = getOneChitAryById(chitChatQueue[0]);
                    cs.bindData( chitChatQueue[0],[] , people , ()=>{

                    });
                }
                O1HD.Canvas().addChild(chatFrame);
                break;
            case DriftChooseType.INFO_MSG:
                //信息告知
                break;
            case DriftChooseType.GOODS:
                //物品 取出所有可选 配置数据
                let paramMap = driftChooseEntity.extraParamsMap;
                let allWeight : number = 0;
                for ( let goodsId in paramMap ) {
                    let weight = paramMap[goodsId];
                    allWeight += Number(weight);
                }
                //根据权重 算出此次获取的随机物品
                let randomNum = Math.floor( Math.random() * allWeight );
                let retGoodsId : number = 0;
                for ( let goodsId in paramMap ) {
                    let weight : number = Number( paramMap[goodsId]);
                    if ( randomNum <= weight ) {
                        retGoodsId = Number(goodsId);
                        break;
                    }
                    randomNum -= weight;
                }
                // 弹窗 获得物品，收入物品
                NormalGameManager._instance.onPushGoods(retGoodsId,double ? 2 : 1 );
                break;
            case DriftChooseType.REGISTER_EVENT:
                //注册 后置事件
                let eventId = driftChooseEntity.effectNums;
                this.registerEventById( eventId );
                break;
            case DriftChooseType.COINS:
                //获得金币
                O1HD.getServices().userSrv.setCoins( driftChooseEntity.effectNums , true , targetNode ? targetNode : null );
                break;
        }

        //如果是唯一的触发以后就移除
        if ( driftChooseEntity.onlyFlag ) {
            this._removeEventById( driftBattleEntity.uniqueId );
        }
        this.mGameLayer.writeGameData();
    }

    //添加延迟事件
    private _addDelayEvent( driftBattleEntity : DriftBattleEntity,driftChooseEntity : DriftChooseEntity ){
        let paramMap = driftChooseEntity.extraParamsMap;
        if ( paramMap ) {
            let nextTriggerDays = paramMap["nextTriggerDays"];
            if ( nextTriggerDays ) {
                if ( !this.mGameLayer.getGameData().delayDriftBattleData ){
                    this.mGameLayer.getGameData().delayDriftBattleData = [];
                }
                let actualTriggerDays = this.mGameLayer.getCurrentDay() + 1 + Number( nextTriggerDays );
                this.mGameLayer.getGameData().delayDriftBattleData
                    .push( {actualTriggerDays:actualTriggerDays,eventId:driftBattleEntity.uniqueId,weight:driftBattleEntity.weight});
            }
        }
    }

    /**
     * 通过id移除
     * @param id
     * @private
     */
    private _removeEventById( id : number ){
        let findIndex = this.mGameLayer.getGameData().driftBattleData.findIndex(( item,index,dataList )=>{
            return item.eventId == id;
        });
        this.mGameLayer.getGameData().driftBattleData.splice( findIndex , 1 );
    }
}

/**
 * 选项类型
 */
export enum DriftChooseType {
    CACHE = 1,//  缓存模块
    WE_CHAT,// 聊天
    INFO_MSG,//信息告知
    GOODS,//物品
    REGISTER_EVENT,//后置事件注册
    COINS,//金币
}
